/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingCurveData } from './bookingCurveData';


export interface BookingCurvesData { 
    targetBookingCurves?: Array<BookingCurveData>;
    currentBookingCurves?: Array<BookingCurveData>;
    historicalBookingCurves?: Array<BookingCurveData>;
    forecastBookingCurves?: Array<BookingCurveData>;
}

